module.exports = __webpack_public_path__ + "img/box-box.edb64b7d.svg";